import { useRef, useEffect, useState } from 'react';
import PalmerSectionLabel from './PalmerSectionLabel';

const footerImgs = [
  'https://framerusercontent.com/images/cTZryjPqV5ZMUtNQzLv4ThG3Rc.png',
  'https://framerusercontent.com/images/U6Lqqgoqd6GcIuLTfi8cdeLwVO4.png',
  'https://framerusercontent.com/images/BUHPRJEXyNtV4SzSuVGHESxLAQ.png',
  'https://framerusercontent.com/images/D5DNZqI6mcEFCYSZWhnmUO1zKY.png',
  'https://framerusercontent.com/images/V8SEwxdOqG25w8pT1yHaJ2id5iw.png',
  'https://framerusercontent.com/images/dNrIdvmFhdP0xZzwxHIhE2HDHk.png',
  'https://framerusercontent.com/images/uBAfSHVa5Eb3SW2z97v14rBRQ.png',
  'https://framerusercontent.com/images/D3Asf5UxG9GSah7Uo0xCvmicn8.png',
];

const quickLinks = [
  { label: 'Home,', href: '/' },
  { label: 'Gallery,', href: '/gallery' },
  { label: 'Work,', href: '/work' },
  { label: 'Contact', href: '/contact' },
];

const socialLinks = [
  { label: 'Instagram,', href: 'https://www.instagram.com/' },
  { label: 'Dribbble,', href: 'https://dribbble.com/' },
  { label: 'LinkedIn,', href: 'https://linkedin.com/' },
  { label: 'Twitter', href: 'https://x.com/' },
];

export default function PalmerFooter() {
  const animRef = useRef<number>(0);
  const [offset, setOffset] = useState(0);
  const imgW = 160;
  const gap = 8;
  const totalW = footerImgs.length * (imgW + gap);
  const doubled = [...footerImgs, ...footerImgs, ...footerImgs];

  useEffect(() => {
    let pos = 0;
    const step = () => {
      pos += 0.6;
      if (pos >= totalW) pos -= totalW;
      setOffset(pos);
      animRef.current = requestAnimationFrame(step);
    };
    animRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(animRef.current);
  }, [totalW]);

  return (
    <footer className="bg-black pt-20 pb-0" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <PalmerSectionLabel left1="© Final Section クロージング" left2="(WDX® — 12)" right="Studio Wrap" />

      {/* Scrolling image marquee */}
      <div className="overflow-hidden mb-12" style={{ height: 180 }}>
        <div
          className="flex h-full"
          style={{ transform: `translateX(-${offset}px)`, width: `${doubled.length * (imgW + gap)}px`, gap: `${gap}px` }}
        >
          {doubled.map((src, i) => (
            <div key={i} className="flex-shrink-0 overflow-hidden" style={{ width: imgW, height: 180 }}>
              <img src={src} alt="" className="w-full h-full object-cover object-top" />
            </div>
          ))}
        </div>
      </div>

      <div className="px-6">
        {/* Big closing text + back to top */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <p className="text-white/35 text-sm leading-relaxed max-w-md">
            We build expressive, performance-driven websites by blending clean design and native development to help creative teams and modern brands stand out with intention.
          </p>
          <div className="flex lg:justify-end items-start">
            <a
              href="#top"
              className="inline-flex items-center gap-2 border border-white/30 text-white text-xs px-5 py-2.5 hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap"
              style={{ letterSpacing: '0.1em' }}
            >
              <i className="ri-arrow-up-line text-xs"></i>
              Back To Top
            </a>
          </div>
        </div>

        {/* Nav links */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <p className="text-white/25 text-xs mb-4">Quick Links</p>
            <div className="flex flex-wrap gap-x-2 gap-y-1">
              {quickLinks.map((l) => (
                <a key={l.href} href={l.href} className="text-white text-sm hover:opacity-40 transition-opacity whitespace-nowrap">{l.label}</a>
              ))}
            </div>
          </div>
          <div>
            <p className="text-white/25 text-xs mb-4">Networks</p>
            <div className="flex flex-wrap gap-x-2 gap-y-1">
              {socialLinks.map((l) => (
                <a key={l.href} href={l.href} target="_blank" rel="noopener noreferrer" className="text-white text-sm hover:opacity-40 transition-opacity whitespace-nowrap">{l.label}</a>
              ))}
            </div>
          </div>
        </div>

        <div className="h-px bg-white/10 mb-6"></div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pb-8">
          <p className="text-white/20 text-xs">© {new Date().getFullYear()} Nova AI Digital LLC. All rights reserved.</p>
          <p className="text-white/20 text-xs">New York — AI &amp; Digital Agency</p>
        </div>
      </div>
    </footer>
  );
}
